export default {
  common: {
    getDataFailed: 'データーの取得に失敗した',
    cancel: '取消し',
    noResult: '結果なし',
    prize: '賞金',
    totalPrize: '総ボーナス',
    round: 'ラウンド',
    time: '時間',
    address: 'アドレス',
    options: '選択肢',
    type: 'タイプ',
    none: '無し',
    executedSuccessfully: '正常に実行されました',
  },
  header: {
    referral: '推奨',
    connect: '接続',
    records: '私のレコード',
    register: '支払い/ステイク',
    disconnect: '接続解除',
    networkHint: 'ネットワークの遅延に注意してください',
  },
  rules: {
    top: '挑戦を迎える準備はできましたか?ここに12の質問があり、1回のラウンドで受賞者は$10,000ドルの賞金プールを共有することができます。',
    title: 'ルール',
    section1: '登録は GMT 午後 12:00 に終了し、イベントは GMT 午後 12:05 に開始します。',
    section2: "このイベントに応募するには、Lifeform Avatarをステイクした上で、1BUSDを支払う必要があります。Lifeform Avatarがない場合、このイベントに応募するには20 BUSDを支払う必要があります。",
    section3: '全部で12の質問があります。1つの質問に対して、あなたは20秒の時間を持って答えを選択し、残りの5秒の中で正しい答えが出てきます。正解すれば、次の質問に進むことができます。',
    section4: 'このラウンドが終わったら、ステーキングを取り消すことができます。',
    section5: '各ラウンドが終わったら、賞品を受賞者に空投します。',
    section6: 'あなたの友達に推薦リンクを送って復活カードを獲得できます。［彼/彼女があなたのリンクを使用してSuperAvatarイベントに登録すると、あなたは復活カードを得ることができます］',
    section7: '復活カードを使ってゲームを続けることができます。復活カード1枚につき1回のチャンスしか与えられません。 ',
    section8: '未使用の復活カードは各ラウンドが終了した後に自動的に無効になります。',
  },
  home: {
    prizePool: '賞金プール',
    totalParticipants: '参加者の数',
    round: 'ラウンド',
    startIn: 'で開始',
    connect: '接続',
    register: '登録',
    registered: '登録済み',
    enter: '進む',
    ongoing: '進行中',
    ended: '終了',
    cumulativeRanking: '累計ランキング',
  },
  register: {
    registerRecords: 'r登録レコード',
    registerForRound: 'ラウンド登録',
    youCanChoose: 'いずれかを選択',
    pay: 'を支払う',
    or: 'また',
    stake: 'ステイク',
    staked: 'ステイク済み',
    paid: '支払い済み',
    inviteFriends: '友達を招待する',
    insufficientFunds: '残額不足',
    registerSuccess: '申し込み成功',
    registerFail: '申し込み失敗',
    onceRegistered: '応募が成功すると、あなたはこのラウンドの記念 メダルをもらえます',
    checkMyMedal: '私の記念メダルをチェックする',
    backToHome: 'トップページに戻る',
  },
  records: {
    myTotalPrize: '私の総賞金',
    myRecordsInSuperAvatar: 'super avatarでのレコードr',
    round: 'ラウンド',
    totalRegistered: '参加者の数',
    totalPrize: '総ボーナス',
    winners: 'ウィナー',
    defeat: 'ディフィート',
    myPrize: '私の賞金',
    myRecordsOfPayStake: '私の支払い/ステイク履歴',
  },
  share: {
    share: 'シェア',
    referralUrlCopied: '招待リンクをコピー済み',
    showItOff: 'シェア',
    invitingYouTo: 'はあなたを誘っています',
    theWinnersTakeAll: '受賞者はすべてを分かち合う',
    yourReferralUrl: 'あなたの推薦リンク',
    downloadAndShare: '写真をダウンロードして共有する',
    comeToWin: 'super avatarに来て賞金をもらおう!',
    iHaveDefeated: 'プレイヤーの ',
    ofThePlayers1: 'を倒しましたが、',
    ofThePlayers2: 'ほとんど勝てませんでした',
    isTheWinnerOfThisRound: 'はこのラウンドの優勝者です。',
    hasWon: '獲得済み',
    comeToTogether: '賞金をもっと獲得しましょう',
    hereRecordOf: 'ゲームレコード',
    knowMore: 'super avatarの詳細へ',
    iHaveWon: '俺の勝ちだ',
    everyDay: '毎日',
    resurrectionCardUsed: '復活カード使用済み',
    everyDay12GMTAAnswer: '毎日午後 12 時 (GMT) に 12 問正解すると、すぐに 10000 BUSD が均等に分配されます。 リンクに参加してください:',
    totalHighAs: '総ボーナス',
    everyDay12GMT: '毎日午後 12 時 (GMT)',
    answer12Today1: '12 の質問に正しく答えると、勝者はその日',
    answer12Today2: 'のすべての賞品を平等に共有します',
    numIHaveDefeated: '',
    numOfThePlayers1: '人のプレイヤーを倒し、',
    numOfThePlayers2: 'ほぼ勝ちました',
    holdDownShare: '写真を長押しして共有',
    win: '勝つ',
  },
  stake: {
    registerByStaking: 'ステーキングで登録する',
    unstakeAllAvatar: 'unstake all avatar',
    chooseYourAvatar: 'あなたのavatarを選択してください',
    stake: 'ステイク',
    unstake: 'ステイク取消',
    unstaked: 'ステイク取消',
    approveToken: '登録のためにトークンを授権してください',
    approveNFT: 'ステイクのためにNFTを授権してください',
  },
  match: {
    watching: '観賞中',
    sorryYouAreOut: 'ごめんなさい。アウトです!',
    wishNext: '次のゲームで勝利することを祈ります!',
    totalPrize: '総ボーナス',
    survivedAndTotal: '生き残る/参加者の数',
    prizeForEach: '1人につき獲得できる賞金',
    rememberTo: 'remember to',
    unstakeYourAvatar: 'unstake your avatar',
    congrats: 'おめでとう!',
    areWinner: 'あなたはこのラウンドの優勝者です.',
    almostWinner: '後少しで優勝者になるところです!',
    keepLearning: '勉強し続き、次のラウンドで優勝しましょうd!',
    toGetCard: '次のラウンドの復活カードを獲得する',
  },
  referral: {
    currentRound1: '今はラウンド',
    currentRound2: 'です',
    inviteYourFriendsTo: 'iあなたの友達を招待し、このラウンドの復活カードをもらいましょう!',
    referralRecords: '推薦記録',
    round: 'ラウンド',
    resurrectionCard: '復活カード',
    usedOrNot: '使用の有無',
    invitedUsers: '招待されたユーザー',
    used: '使用済み',
    unused: '未使用',
    none: '無し',
    viewDetails: '詳細を見る',
  },
};